// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2-2_t","inputWrap":"styles_inputWrap__2xD3N","input":"styles_input__xkk21"};